<template>
    <UserForm :url="url" :user="user" :roles="roles" :profile="true" :errors="errors" v-on:save="saveUser"></UserForm>
</template>

<script>
import UserForm from './UserForm'
export default {
  name: 'UserEdit',
  components: {UserForm},
  props: ['url'],
  data () {
    return {
      user: {
        shipping: {},
        billing: {},
        roles: []
      },
      errors: {},
      roles: []
    }
  },
  methods: {
    saveUser () {
      let self = this

      this.$http
        .put(this.url + `/update/${this.$route.params.id}`, self.user, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.role = res.data.data
            this.$router.push('/admin/user/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', 'User ' + this.$translate.t('Edit'))

    let self = this
    this.$http
      .get(this.url + `/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.user = res.data.data

        if (self.user.shipping == null) {
          self.user.shipping = {}
        }
        if (self.user.billing == null) {
          self.user.billing = {}
        }

        let aclep = process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/acl'

        self.$http
          .get(aclep + '/index', {
            'headers': {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              'language': self.$store.state.loading.language
            }
          }).then(res => {
            self.roles = res.data

            if (self.user.roles == null) {
              self.user.roles = []
            } else {
              for (let it in self.user.roles) {
                self.user.roles[it] = self.user.roles[it].id
              }
            }
          }).catch(res => {

          })
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/user/UserEdit.vue